<div *ngIf="docUploadAccordioanModal" class="overlaydocupload" [ngClass]="{'in':docUploadAccordioanModal}">
  <div>
    <div class="modal-header" tabindex="0" [ngClass]="{
      'empvol-header': isEmpVolID,
      'emppay-header':isEmpPay,
      'certification-header':isCert,
      'signedletter-header':isSignedLetter
    }">
      <div class="row" id="headercontent">
        <h1 style="display:none;">Fix for sonar issues</h1>
        <h2 style="display:none;">Fix for sonar issues</h2>
        <h3 style="display:none;">Fix for sonar issues</h3>
        <img src="assets/images/C028_EmployeeID_32.png" alt="EmpOrVolID" *ngIf="isEmpVolID">
        <h4 *ngIf="isEmpVolID" modal-title tabindex="0" class="modal-heading"
          [innerHTML]="cfetLabels.cfet_doc_upload.employee_badge_heading"></h4>

        <img src="assets/images/C026_Billing_32.png" alt="Billing" *ngIf="isEmpPay">
        <h4 *ngIf="isEmpPay" modal-title tabindex="0" class="modal-heading">
          {{cfetLabels.cfet_doc_upload.employee_pay_stub_heading}}
        </h4>

        <img src="assets/images/C018_File_24.png" alt="Certification" *ngIf="isCert">
        <h4 *ngIf="isCert" modal-title tabindex="0" class="modal-heading">
          {{cfetLabels.cfet_doc_upload.certification_heading}}</h4>

        <img src="assets/images/C062_My_Notes_32.png" alt="Signed Letter" *ngIf="isSignedLetter">
        <h4 *ngIf="isSignedLetter" modal-title tabindex="0" class="modal-heading">
          {{cfetLabels.cfet_doc_upload.signed_letter_heading}}</h4>

        <div class="corner-button" tabindex="0" [ngClass]="{'corner-button-mobile' : mobileView && (isCert || isSignedLetter),
          'corner-button-mobile-id': mobileView && isEmpVolID}">
          <button type="button" class="close-modal-button" [attr.aria-label]="'Close'" tabindex="0"
            (click)="close($event, 'modalAction1')">
            <em aria-label="Close" tabindex="-1" class="icon-close modal-close-icon" role="img"></em>
          </button>
        </div>
      </div>
    </div>
    <div class="modal-body" id="modal-content-id" tabindex="0" modal-content aria-label="Modal body text content">
      <div *ngIf="isEmpVolID">
        <div class="row employee-id-desc-column" id="employee-id-desc-column">
          <p *ngIf="agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.employee_badge_desc}}</p>
          <p *ngIf="!agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.employee_badge_desc_agent}}
          </p>
        </div>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>

        <div class="row employee-id-desc-column" id="employee-id-desc-column">
          <div *ngIf="userFacing">
            <div id="id-badge-acc-desc" class="id-badge-acc-desc">
              <p class="p-small">{{cfetLabels.cfet_doc_upload.employee_badge_bullet1_part1}}
                <strong>{{fname}} </strong>
                <strong>{{lname}}</strong>{{cfetLabels.cfet_doc_upload.employee_badge_bullet1_part2}}
              </p>
            </div>
            <div class="dividercomp section">
              <div class="row" id="action-divider"></div>
            </div>
            <p class="p-small">{{cfetLabels.cfet_doc_upload.employee_badge_bullet4_part1}}
              <strong>{{selectedOrg}}</strong>
              {{cfetLabels.cfet_doc_upload.employee_badge_bullet4_part2}}
            </p>
          </div>
        </div>
      </div>

      <div *ngIf="isEmpPay">
        <div class="row pay-stub-desc-column" id="pay-stub-desc-column">
          <p *ngIf="!agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.employee_pay_stub_desc}}</p>
          <p *ngIf="agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.employee_pay_stub_desc_agent}}</p>
        </div>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <div *ngIf="userFacing">
          <div id="pay-stub-acc-desc" class="row pay-stub-acc-desc">
            <p class="p-small">{{cfetLabels.cfet_doc_upload.employee_pay_stub_bullet1}}</p>
          </div>
          <div class="dividercomp section">
            <div class="row" id="action-divider"></div>
          </div>
          <p class="p-small">{{cfetLabels.cfet_doc_upload.employee_pay_stub_bullet2_part1}}
            <strong>{{fname}} </strong>
            <strong>{{lname}}</strong>{{cfetLabels.cfet_doc_upload.employee_pay_stub_bullet2_part2}}
          </p>
          <div class="dividercomp section">
            <div class="row" id="action-divider"></div>
          </div>
          <p class="p-small">{{cfetLabels.cfet_doc_upload.employee_pay_stub_bullet3_part1}}
            <strong>{{selectedOrg}}</strong>{{cfetLabels.cfet_doc_upload.employee_pay_stub_bullet3_part2}}
          </p>
          <div class="dividercomp section">
            <div class="row" id="action-divider"></div>
          </div>
          <p class="p-small">{{cfetLabels.cfet_doc_upload.employee_pay_stub_bullet8}}</p>
        </div>
      </div>

      <div *ngIf="isCert">
        <div class="row certification-desc-column" id="certification-desc-column">
          <p *ngIf="!agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.certification_desc}}</p>
          <p *ngIf="agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.certification_desc_agent}}</p>
        </div>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <div *ngIf="userFacing">
          <div id="certification-desc" class="row certification-desc">
            <p class="p-small">{{cfetLabels.cfet_doc_upload.certification_bullet4}}</p>
            <ul>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.certification_bullet4_part1}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.certification_bullet4_part2}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.certification_bullet4_part3}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.certification_bullet4_part4}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.certification_bullet4_part5}}</li>
            </ul>
          </div>
        </div>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <p class="p-small">{{cfetLabels.cfet_doc_upload.certification_bullet5}}</p>
        <p class="p-small nmt-1"> <strong>{{fname}} {{lname}}</strong></p>
      </div>

      <div *ngIf="isSignedLetter">
        <div class="row signed-letter-desc-column" id="signed-letter-desc-column">
          <p *ngIf="!agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_desc}}</p>
          <p *ngIf="agentFacingDesc" class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_desc_agent}}</p>
        </div>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <div *ngIf="userFacing">
          <div id="signed-letter-desc" class="row signed-letter-desc">
            <ul>
              <li class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_bullet5}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.signed_letter_bullet6}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.signed_letter_bullet7}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.signed_letter_bullet8}}</li>
              <li class="extra-space pl-2">{{cfetLabels.cfet_doc_upload.signed_letter_bullet15}}</li>
              <li class="extra-space">{{cfetLabels.cfet_doc_upload.signed_letter_bullet9}}</li>
              <li class="extra-space pl-2">{{cfetLabels.cfet_doc_upload.signed_letter_bullet16}}</li>
              <li class="extra-space pl-2">{{cfetLabels.cfet_doc_upload.signed_letter_bullet17}}</li>
              <li class="extra-space right-space">{{cfetLabels.cfet_doc_upload.signed_letter_bullet19}}</li>
            </ul>
          </div>
        </div>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <p class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_bullet10}} </p>
        <p class="p-small nmt-1"><strong>{{fname}} {{lname}}</strong></p>

        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <p class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_bullet11}}</p>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <p class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_bullet12}}</p>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <p class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_bullet13}}</p>
        <div class="dividercomp section">
          <div class="row" id="action-divider"></div>
        </div>
        <p class="p-small">{{cfetLabels.cfet_doc_upload.signed_letter_bullet14}}</p>
      </div>

    </div>
    <div class="modal-footer" id="modal-footer-content" tabindex="0">
      <div class="col-md-12">
        <div id="employee-badge-image" class="row employee-badge-image" *ngIf="isEmpVolID">
          <div class="col-md-6">
            <img src="assets/images/Group 901.png" alt="Employee or Volunteer ID">
          </div>
          <div class="col-md-6">
            <img src="assets/images/Group 900.png" alt="Employee or Volunteer ID" id="emp-back-side">
          </div>
        </div>

        <div id="employee-stub-image" class="row employee-stub-image" *ngIf="isEmpPay">
          <img src="assets/images/Pay Stub.png" alt="Employee Pay Stub">
        </div>

        <div id="certification-image" class="row certification-image" *ngIf="isCert">
          <img src="assets/images/certification.png" alt="Certification">
        </div>

        <div id="signed-letter-image" class="row signed-letter-image" *ngIf="isSignedLetter">
          <img src="assets/images/Signed Letter.png" alt="Signed Letter">
        </div>
      </div>
    </div>
  </div>
</div>